
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getInstallScourceList } from '@/api/installScource';

@Component({
  name: 'installSourceDialog'
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  installVisible!: Boolean;

  private installQuery: any = {}
  private dataTableInstall: any = []
  private installSelection: any = ''
  private installPage: any = {
    page: 1,
    size: 9999
  }
  private moreLoading = false

  created() {
    this.getInstallScourceList();
  }
  private getInstallScourceList() {
    let paramters:any = {};
    paramters.user_id = UserModule.getUserId;
    paramters.company_id = UserModule.getCompanyId;
    paramters.page = this.installPage.page;
    paramters.size = this.installPage.size;
    paramters.name = this.installQuery.name;

    getInstallScourceList(paramters).then(res => {
      if (res.data) {
        if (this.installPage.page === 1) {
          this.dataTableInstall = res.data.list;
        } else {
          this.dataTableInstall = this.dataTableInstall.concat(res.data.list);
        }

        if (this.installPage.page < res.data.page_count) {
          this.moreLoading = true;
        } else {
          this.moreLoading = false;
        }
      } else {
        this.installPage.total = 0;
        this.dataTableInstall = [];
      }
    }).catch(err => {
      let msg = err.msg;
      this.dataTableInstall = [];
    });
  }
  private moreData() {
    this.installPage.page++;
    this.getInstallScourceList();
  }
  private installSearch() {
    this.installPage.page = 1;
    this.getInstallScourceList();
  }
  private installClear() {
    this.installQuery.name = '';
    this.installPage.page = 1;
    this.getInstallScourceList();
  }

  private close() {
    this.$emit('close', false);
  }
  private installSubmit() {
    this.$emit('installSubmit', this.installSelection);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
